import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import StatusService from '../../components/StatusService';
import { instanceAxios } from '../../InstanceAxios';
import { MSG_ERRO, XMEI_PRIMARY_COLOR } from '../../consts/common';
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import FilterIcon from "@material-ui/icons/FilterList";

const columns = [
  { id: 'servico', label: 'Serviço', minWidth: 170, filterable: true, path: 'Servico.nome' },
  { id: 'solicitante', label: 'Solicitante', minWidth: 170, filterable: true, path: 'Usuario.nome' },
  { id: 'data', label: 'Data Solicitação', minWidth: 170, filterable:   true, path: 'createdAt' },
  { id: 'admin', label: 'Responsável', minWidth: 170, filterable: true , path: 'Admin.nome'},
  { id: 'status', label: 'Status', minWidth: 80, filterable: true, path: 'status' },
  { id: 'editar', label: 'Editar', minWidth: 80, filterable: false },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

function GuiaTributos() {
  useEffect(() => {
    atualizarServicos(10, 0);
  }, []);

  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalServicos, setOriginalServicos] = useState([]);

  const [servicos, setServicos] = useState([]);
  const [abrirAlert, setAbrirAlert] = useState(false);
  const [tipoAlerta, setTipoAlerta] = useState('');
  const [msgAlerta, setMsgAlerta] = useState('');
  const [ready, setReady] = useState(true);
  const [servico, setServico] = useState({ id: 0 });

  const atualizarServicos = async (rpg, p) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/servicosDas?limit=${rpg}&page=${p}`)
      .then((res) => {
        console.log(res.data);
        setServicos(res.data);
        setOriginalServicos(res.data);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setMsgAlerta(MSG_ERRO);
        setTipoAlerta('error');
        setAbrirAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    atualizarServicos(rowsPerPage, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    atualizarServicos(event.target.value, 0);
  };

  const handleClose = () => {
    setAbrirAlert(false);
    setMsgAlerta('');
    setTipoAlerta('');
  };

  const handleEdit = (s) => setServico(s);

  const handleChangeStatus = async (s) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .put(`/atualizarStatusServico`, {
        id: s.id,
        status: servico.status,
      })
      .then((res) => {
        setMsgAlerta('Status Alterado com sucesso!');
        setTipoAlerta('success');
        setAbrirAlert(true);
        setServico({ id: 0 });
        setReady(true);
        atualizarServicos(rowsPerPage, page);
      })
      .catch((err) => {
        setMsgAlerta('Erro ao alterar status,tente mais tarde!');
        setTipoAlerta('error');
        setAbrirAlert(true);
        setServico({ id: 0 });
        setReady(true);
      });
  };

  const editStatus = (status) => {
    setServico({
      ...servico,
      status,
    });
  };

  const redirect = (s) => {
    window.location = `/das?cnpj=${s.Usuario.UsuarioEmpresa.Empresa.cnpj}&razao=${s.Usuario.UsuarioEmpresa.Empresa.razao_social}`;
  };


  const openModalFilter = (event, columnid) => {
    setFilterText('')
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top , left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalServicos.filter(item => {
      const value = getValueColumnId(columnId,item);
      return value && value.toString().toLowerCase().includes(filterText.toLowerCase());
    });
    // Update the table data with filtered data
    setServicos(filteredDas);
  };

  const getValueColumnId = (columnIdAux,rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  }

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setServicos(originalServicos);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;


    if (idOrder === property && order === 'desc') {
      setOrder('asc')
    }else{
      setOrder('desc')
    }


    setIdOrder(orderBy);

  };

  const sortTable = (property) => {


    const isAsc = order === 'asc';
    console.log(servicos);
    servicos.sort((a, b) => {
      let aValue = getValueColumnId(property,a);
      let bValue = getValueColumnId(property,b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setServicos(servicos);
  };

  return (
    <>
      <Modal open={isModalOpen} onClose={closeModal} style={{ top: modalPosition.top, left: modalPosition.left }}>
        <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '5px', width: '300px' }}>
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button variant="contained" color="primary" onClick={filterTable} style={{ marginTop: '10px' }}>
            Filtrar
          </Button>
          <Button  variant="contained" color="secondary" onClick={clearFilter} style={{ marginTop: '10px',marginLeft: '5px',width:70 }}>
            Limpar
          </Button>
        </div>
      </Modal>
      <Grid container direction="row" justify="center" alignItems="center">
        <h1>Guia e Tributos</h1>
      </Grid>
      <Collapse in={ready}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{minWidth: column.minWidth}}
                      >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                          <TableSortLabel
                            active={idOrder === column.id}
                            direction={idOrder === column.id ? order : 'asc'}
                            onClick={() => {
                              handleRequestSort(column.path);
                              setTimeout(() => {
                                sortTable(column.path);
                              }, 200);
                            }}
                          >
                            {column.label}
                          </TableSortLabel>

                          {column.filterable && (
                            <IconButton style={{marginLeft:-5}}   onClick={event => openModalFilter(event,column.path)} aria-label="filtra">
                              <FilterIcon style={{width:16,height:16  }} />
                            </IconButton>
                          )}
                        </div>

                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {servicos.map((s) => {
                    return (
                      <TableRow key={s.id}>
                        <TableCell component="th" scope="row" align="center">
                          {s.Servico.nome}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {s.Usuario.nome}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {moment(s.createdAt).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {s.Admin ? s.Admin.nome : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {servico.id === s.id ? (
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={servico.status}
                              onChange={(event) =>
                                editStatus(Number(event.target.value))
                              }
                            >
                              <MenuItem value={1}>Em Aberto</MenuItem>
                              <MenuItem value={2}>Andamento</MenuItem>
                              <MenuItem value={3}>Feito</MenuItem>
                              <MenuItem value={4}>Cancelado</MenuItem>
                            </Select>
                          ) : (
                            <StatusService
                              status={s.status}
                              handle={() => redirect(s)}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {servico.id === s.id ? (
                            <>
                              <IconButton
                                onClick={() => handleEdit({ id: 0 })}
                                style={{
                                  color:
                                    servico.id === s.id
                                      ? 'red'
                                      : XMEI_PRIMARY_COLOR,
                                }}
                                aria-label="cancelar"
                              >
                                <CancelIcon />
                              </IconButton>
                              <IconButton
                                onClick={() => handleChangeStatus(s)}
                                style={{
                                  color:
                                    servico.id === s.id
                                      ? 'green'
                                      : XMEI_PRIMARY_COLOR,
                                }}
                                aria-label="salvar"
                              >
                                <CheckIcon />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              onClick={() => handleEdit(s)}
                              style={{
                                color:
                                  servico.id === s.id
                                    ? 'red'
                                    : XMEI_PRIMARY_COLOR,
                              }}
                              aria-label="Editar"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={servicos.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Collapse>
      <Collapse in={!ready}>
        <CircularProgress style={{ marginLeft: '50%' }} />
      </Collapse>

      <Snackbar open={abrirAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity={tipoAlerta} onClose={handleClose}>
          {msgAlerta}
        </Alert>
      </Snackbar>
    </>
  );
}

export default GuiaTributos;
